import { createComponentState } from '@/state';

export type ManifestPreviewState = {
  invalidStagedTrips: {
    [key: string]: Record<string, string>;
  };
};

export type ManifestState = {
  manifestPreview: ManifestPreviewState;
  /** Per-stagedTrip excluded flag IDs (overrides server data after modal saves). */
  excludedFlags: Record<string, string[]>;
  /** Tracks the active importId so flag state can be reset on navigation. */
  lastImportId?: string;
};

export const initManifestState: ManifestState = {
  manifestPreview: {
    invalidStagedTrips: {},
  },
  excludedFlags: {},
  lastImportId: undefined,
};

export const useManifestState = createComponentState(initManifestState);
